/**
 * Whether the browser says it has a connection, as reactive state: the
 * Versus tab dims its doors and says why when it does not, because every one
 * of them needs the server. Solo play never reads this (BASELINE 5).
 *
 * `navigator.onLine` is a hint, not a promise: `true` only means there is a
 * network interface. That is the right strength for a hint on a tab; whether
 * a room can really be reached is still decided by trying.
 */
const hasNavigator = typeof navigator !== 'undefined';

export const connection = $state({ online: hasNavigator ? navigator.onLine !== false : true });

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    connection.online = true;
  });
  window.addEventListener('offline', () => {
    connection.online = false;
  });
}
